<template>
    <div :class="`as-who-will-score ${mode}`">
        <div class="as-who-will-score__head">
            <IconGoalScored fill="#FFAE00"/>
            <span v-if="mode == 'as-win'"> Liệu đội {{ footyStats?.home_name }} sẽ ghi điểm?  </span>
            <span v-if="mode == 'as-loss'"> Liệu đội {{ footyStats?.away_name }} sẽ ghi điểm?  </span>
        </div>
        <div class="as-who-will-score__body">
            <div class="as-item">
                <FootballTeamItem :awayPoint="footyStats?.pre_match_home_ppg ?? 0" :homePoint="footyStats?.pre_match_away_ppg ?? 0" :footyStats="footyStats" :match="match" modifyClass="as-vertical" :showName="false" :showResult="false"/>
                <div class="as-item__sub" v-if="mode == 'as-win'">
                    <span>Ghi bàn trong</span>
                    <span>{{ getValueWithMode('home', 'firstGoalScoredPercentage_overall') }}%</span>
                    <span>của các trận đấu (Overall)</span>
                </div>
                <div class="as-item__sub" v-if="mode == 'as-loss'">
                    <span>Giữ sạch lưới ở</span>
                    <span>{{ getValueWithMode('home', 'seasonCSPercentage_overall') }}%</span>
                    <span>của các trận đấu (Overall)</span>
                </div>
            </div>
            
            <div class="as-vs">
                <div class="as-vs__tile">
                    <IconOpportunity v-if="mode == 'as-win'"/>
                    <IconUncertain v-if="mode == 'as-loss'"/>
                    {{ mode == 'as-win' ? 'Cơ hội trung bình' : 'Không chắc chắn' }}
                </div>
                <div class="as-vs__line">
                    <div class="as-vs-line-item" v-if="mode == 'as-win'">
                        <div class="as-vs-line-item__main">
                            
                        </div>
                        <div class="as-vs-line-item__win" :style="{
                            width: `${getValueWithMode('home', 'firstGoalScoredPercentage_overall')}%`
                        }">

                        </div>
                        <div class="as-vs-line-item__draw" style="width: 100%;">

                        </div>
                        <div class="as-vs-line-item__loss">

                        </div>
                        <div class="as-vs-line-item__ball as-no-ball">
                            <div class="as-icon">
                                <IBall/>
                            </div>
                        </div>
                    </div>
                    <div class="as-vs-line-item" v-if="mode == 'as-loss'">
                        <div class="as-vs-line-item__main">
                            
                        </div>
                        <div class="as-vs-line-item__win" :style="{
                            width: `${getValueWithMode('home', 'seasonCSPercentage_overall')}%`
                        }">

                        </div>
                        <div class="as-vs-line-item__draw" style="width: 100%;">

                        </div>
                        <div class="as-vs-line-item__loss">

                        </div>
                        <div class="as-vs-line-item__ball as-no-ball">
                            <div class="as-icon">
                                <IBall/>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="as-vs__text" v-if="mode === 'as-win'">
                    <span class="as-bold">Cơ hội trung bình {{ footyStats?.home_name }} </span> sẽ có bàn thắng dựa trên dữ liệu
                </div>
                <div class="as-vs__text" v-if="mode === 'as-loss'">
                    <span class="as-bold">Không chắc chắn {{ footyStats?.away_name }} </span> sẽ có bàn thắng dựa trên dữ liệu
                </div>
            </div>
            <div class="as-item">
                <FootballTeamItem :awayPoint="footyStats?.pre_match_home_ppg ?? 0" :homePoint="footyStats?.pre_match_away_ppg ?? 0" :footyStats="footyStats" :match="match" modeTeam="as-away" modifyClass="as-vertical" :showName="false" :showResult="false" status="as-W"/>
                <div class="as-item__sub as-right" v-if="mode == 'as-win'">
                    <span>Giữ sạch lưới ở</span>
                    <span>{{ getValueWithMode('away', 'seasonCSPercentage_overall') }}%</span>
                    <span>của các trận đấu (Overall)</span>
                </div>
                <div class="as-item__sub as-right" v-if="mode == 'as-loss'">
                    <span>Ghi bàn trong</span>
                    <span>{{ getValueWithMode('away', 'firstGoalScoredPercentage_overall') }}%</span>
                    <span>của các trận đấu (Overall)</span>
                </div>
            </div>
            
        </div>
    </div>
</template>
<script setup lang="ts">
    import IconGoalScored from '~src/components/icons/foot_stats/IconGoalScored.vue';
    import IBall from '~src/components/icons/incident/IBall.vue';
    import FootballTeamItem from '../FootballTeamItem.vue';
    import IconCorner from '~src/components/icons/foot_stats/IconCorner.vue';
    import IconPadlock from '~src/components/icons/IconPadlock.vue';
    import IconOpportunity from '~src/components/icons/foot_stats/IconOpportunity.vue';
    import IconUncertain from '~src/components/icons/foot_stats/IconUncertain.vue';
    import type { IMatch } from '~src/interfaces';
    import type { IFootyStats, ITeam, IStatsParent } from '~src/interfaces/footystats';
    import { ref } from 'vue';

    interface Props{
        match: IMatch;
        mode?: string;
        footyStats: IFootyStats | null;
        homeTeamInfo: ITeam | null;
        awayTeamInfo: ITeam | null;
    }

    const props = withDefaults(defineProps<Props>(),{
        mode: 'as-win'
    })

    const getValueWithMode = (team = 'home', mode = 'btts', mode_half = '') => {
        // const __data: ITeam | null = team === 'home' ? props.homeTeamInfo : props.awayTeamInfo;

        const __data: IStatsParent | null = 
            props.footyStats 
                ? (team === 'home' 
                    ? props.footyStats.home_team_last_x 
                    : props.footyStats.away_team_last_x) 
                : null;

                let __mode = mode
        if(mode_half){
            __mode = mode_half
        }
        if (!__data || !__data.stats || !__data.stats.hasOwnProperty(__mode)) {
            return 0; 
        }

        return __data.stats[__mode] as number;
    }

    

    const calculatorAVG = (home: number, away: number) => {
        const _avg = (home + away) / 2

        return Math.round(_avg)
    }

    const calculatorPercent = (home: number, away: number, mode = 'home') => {
        const _total = (home + away)
        if(_total > 0){
            return Math.round((home / _total) * 100)
        }

        return 0;
    }

</script>
<script lang="ts">
export default {};
</script>